export default __webpack_public_path__ + "static/media/8.edd68536.png";